import { startPerformanceMeasure } from '@vend/utilities'
import { useCallback } from 'react'
import { STATES } from '../../../../../../lib/routes'
import { isValidCustomer } from '../../../../functions/sale'
import {
  useCustomerManager,
  useIsCalculatingSale,
  useTrainingModeManager,
  useWorkflowsManager,
} from '../../../../ng-compat/hooks'
import { $state } from '../../../../ng-compat/imports'
import { useAppDispatch, useAppSelector } from '../../../../state/hooks'
import { selectSaleCustomer } from '../../../../state/slices/currentSale/currentSaleSlice'
import {
  finalisingSale,
  finalisingSaleComplete,
  workflowsComplete,
  workflowsStarted,
} from '../../../../state/slices/uiStateSlice'
import { useCanTransitionToPaymentScreen } from './use-can-transition-to-payment-screen'

export const useTransitionToPaymentScreen = (
  lspayQuickPaySelected?: boolean
) => {
  const dispatch = useAppDispatch()
  const trainingModeManager = useTrainingModeManager()
  const customerManager = useCustomerManager()
  const workflowsManager = useWorkflowsManager()
  const customer = useAppSelector(selectSaleCustomer)
  const canTransitionToPaymentScreen = useCanTransitionToPaymentScreen()
  const isCalculating = useIsCalculatingSale()

  return useCallback(async () => {
    if (!canTransitionToPaymentScreen || isCalculating) {
      return
    }

    dispatch(finalisingSale())

    if (!trainingModeManager.trainingModeEnabled) {
      // time how long it takes to tender a sale
      startPerformanceMeasure('sale-process')
      // start timing how long it takes to initiate a sale with a payment type
      startPerformanceMeasure('select-payment-type-process')
    }

    const customerRefreshPromise = isValidCustomer(customer)
      ? customerManager.refreshCustomer(customer)
      : Promise.resolve()

    try {
      await customerRefreshPromise

      dispatch(workflowsStarted())
      const shouldProceed = await workflowsManager.readyForPayment({
        element: document.getElementById('wr-pay-button')!,
        placement: 'top',
      })

      if (shouldProceed) {
        $state.go(STATES.PAYMENT, {
          lspayQuickPaySelected,
        })
      }
    } finally {
      dispatch(workflowsComplete())
      dispatch(finalisingSaleComplete())
    }
  }, [
    canTransitionToPaymentScreen,
    customer,
    customerManager,
    dispatch,
    isCalculating,
    lspayQuickPaySelected,
    trainingModeManager.trainingModeEnabled,
    workflowsManager,
  ])
}
